__turbopack_context__.v({
  "betty-bot-block": "IjxLFq_betty-bot-block",
  "betty-bot-block__instance": "IjxLFq_betty-bot-block__instance",
  "betty-bot-block__loader": "IjxLFq_betty-bot-block__loader",
  "betty-bot-block__logo": "IjxLFq_betty-bot-block__logo",
  "betty-bot-block__logo--desktop": "IjxLFq_betty-bot-block__logo--desktop",
  "betty-bot-block__logo--mobile": "IjxLFq_betty-bot-block__logo--mobile",
});
